<div class="menu desktop" [style.width]="isOpen ? '240px' : '80px'">
  <div class="content" [style.width]="isOpen ? '190px' : '36px'" [ngClass]="{content_close: !isOpen}">
    <div class="logo">
      @if(isOpen) {
      <img src="../../../assets/images/logo-menu.png" alt="" srcset="" (click)="openClose()">
      } @else {
      <span class="material-symbols-outlined hamb" (click)="openClose()">
        <img src="../../../assets/images/Group.png" alt="">
      </span>
      }
    </div>
    <ul class="items">
      <!-- @if(loading) { -->
      @for(item of menu; track item){
      <li class="item" [ngClass]="{li_close: !isOpen}" [appTooltip]="item.label" [tooltipPosition]="'right'">
        <a href="" [ngClass]="{selected: item.checked}" [routerLink]="item.route">
          <span class="material-symbols-outlined">
            {{item.icon}}
          </span>
          <div class="item-description" [ngClass]="{item_description_close: !isOpen}">{{item.label}}</div>
        </a>
      </li>
      }
      <!-- } @else {
      <div class="skeleton-list">
        @for (item of [1,2,3,4,5,6,7,8]; track $index) {
        <div class="skeleton-item">
          <div class="lines">
            <div class="line"></div>
          </div>
        </div>
        }

      </div>
      } -->
    </ul>
  </div>
</div>

<div class="mobile">
  <ul class="items">
    @for(item of menu.slice(0, 3); track item) {
    <li class="item">
      <a href="" [routerLink]="item.route" (click)="fecharMenu()">
        <span class="material-symbols-outlined" [ngClass]="{selected: !item.checked ? item.checked : !isMobile}">
          {{item.icon}}
        </span>
        <div class="item-description" [ngClass]="{item_description_close: !isOpen}">
          {{item.label}}
        </div>
      </a>
    </li>
    }
    <li class="item" (click)="openMenuMobile()">
      <a>
        <span class="material-symbols-outlined" [ngClass]="{selected: isMobile}">
          more_horiz
        </span>
        <div class="item-description" [ngClass]="{item_description_close: !isOpen}">
          Menu
        </div>
      </a>
    </li>
  </ul>
</div>

@if(isMobile && role?.id === PermissaoEnum.ROLE_RESPONSAVEL) {
<div class="moreMenu">
  <div class="items">
    @for(item of more_menu; track item) {
    <li class="item">
      <a href="" [routerLink]="item.route" (click)="openMenuMobile(item.component)">
        <span class="material-symbols-outlined" [ngClass]="{selected: item.checked ? item.checked : !isMobile}">
          {{item.icon}}
        </span>
        <div class="item-description" [ngClass]="{item_description_close: !isOpen}">
          {{item.label}}
        </div>
      </a>
    </li>
    } @empty {
    <div class="empty">
      <img src="../../../../../../../assets/images/turma-empty.png" alt="">
      <span>Menu Vazio !</span>
    </div>
    }

  </div>
</div>
} @else if (isMobile) {
<div class="moreMenu">
  <div class="items">
    @for(item of menu.slice(3, menu.length); track item) {
    <li class="item">
      <a href="" [routerLink]="item.route" (click)="openMenuMobile()">
        <span class="material-symbols-outlined" [ngClass]="{selected: item.checked ? item.checked : !isMobile}">
          {{item.icon}}
        </span>
        <div class="item-description" [ngClass]="{item_description_close: !isOpen}">
          {{item.label}}
        </div>
      </a>
    </li>
    } @empty {
    <div class="empty">
      <img src="../../../../../../../assets/images/turma-empty.png" alt="">
      <span>Menu Vazio !</span>
    </div>
    }
    <!-- } -->
  </div>
</div>
}

@if(openMoreMenu === 'aluno') {
<div class="menuAluno">
  <div class="items">
    <div class="item-header">
      <span class="material-symbols-outlined close" (click)="back()">arrow_back</span>
      <p>Aluno</p>
      <div></div>
    </div>
    @if(component === 'Todos') {
    <div class="item-content">
      <div class="itens-menu">
        @for (item of dadosAluno; track $index) {
        <div class="card" (click)="mostrarComponent(item.label)">
          <p>{{item.label}}</p>
          <span class="material-symbols-outlined">
            chevron_right
          </span>
        </div>
        }
      </div>
    </div>
    } @else {
    @switch (component) {
    @case('Dados do Aluno') {
    <app-dados-aluno></app-dados-aluno>
    }
    @case('Ficha Médica') {
    <app-ficha-medica></app-ficha-medica>
    }
    @case('Fotos do Aluno') {
    <app-fotos-aluno></app-fotos-aluno>
    }
    @case('Histórico') {
    <app-historico></app-historico>
    }
    @case('Documentos') {
    <app-documentos></app-documentos>
    }
    }
    }
  </div>
</div>
}

@if(openMoreMenu === 'calendario') {
<div class="menuAluno">
  <div class="items">
    <div class="item-header">
      <span class="material-symbols-outlined close" (click)="openMenuMobile()">arrow_back</span>
      <p>Agenda</p>
      <div></div>
    </div>
    <app-agenda></app-agenda>
  </div>
</div>
}



<!-- @if(role === RoleEnum.RESPONSAVEL) {
      @for(item of menu.slice(3, menu.length); track item) {
        <li class="item">
          <a href="" [routerLink]="item.route" (click)="openMenuMobile()">
            <span class="material-symbols-outlined" [ngClass]="{selected: item.checked ? item.checked : !isMobile}">
              {{item.icon}}
            </span>
            <div class="item-description" [ngClass]="{item_description_close: !isOpen}">
              {{item.label}}
            </div>
          </a>
        </li>
        }
    } @else { -->


<!-- <div class="moreMenu">
  <div class="items">
    <div class="item-header">
      <span class="material-symbols-outlined close">arrow_back</span>
      <p>Aluno</p>
      <div></div>
    </div>
    <!-- @for(item of menu.slice(3, menu.length); track item) {
    <li class="item">
      <a href="" [routerLink]="item.route" (click)="openMenuMobile()">
        <span class="material-symbols-outlined" [ngClass]="{selected: item.checked ? item.checked : !isMobile}">
          {{item.icon}}
        </span>
        <div class="item-description" [ngClass]="{item_description_close: !isOpen}">
          {{item.label}}
        </div>
      </a>
    </li>
    } @empty {
    <div class="empty">
      <img src="../../../../../../../assets/images/turma-empty.png" alt="">
      <span>Menu Vazio !</span>
    </div>
    } -->
<!-- } -->
<!-- </div>
</div>  -->
